var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layerpopup-cont type-2",staticStyle:{"border":"none","width":"700px","max-height":"800px"}},[_c('modal-iframe',{attrs:{"src":_vm.remoteSrc,"spinner-id":"edit-account-loading","custom-style":{ 'height': '800px' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }